<template>
  <div class="map-wrap">
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4689.529093205948!2d106.66850367573625!3d10.811532458543805!2m3!
      1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x317529d9ba5ecbad%3A0x5ed587926bad6094!2zVHJ1bmcgdMOibSBIdeG6pW4gbHV54buHbiBCYXktRl
      RD!5e1!3m2!1svi!2s!4v1727944271162!5m2!1svi!2s" class="map-iframe" style="border:0;" allowfullscreen="" loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"></iframe>
    <!-- <a href="https://www.maptiler.com" class="watermark"><img @contextmenu.prevent src="https://api.maptiler.com/resources/logo.svg"
        alt="MapTiler logo" /></a>
    <div class="map" ref="mapContainer"></div> -->
  </div>
</template>

<script>
// import { Map, NavigationControl, Marker } from 'maplibre-gl'
// import { shallowRef, onMounted, onUnmounted, markRaw } from 'vue'

// export default {
//   setup () {
//     const mapContainer = shallowRef(null)
//     const map = shallowRef(null)

//     onMounted(() => {
//       const apiKey = 'ramIIgnisUYF8CeIPPZ4'
//       const initialState = { lng: 106.67006969045394, lat: 10.812570060914288, zoom: 17 }

//       map.value = markRaw(new Map({
//         container: mapContainer.value,
//         style: `https://api.maptiler.com/maps/streets-v2/style.json?key=${apiKey}`,
//         center: [initialState.lng, initialState.lat],
//         zoom: initialState.zoom
//       }))
//       map.value.addControl(new NavigationControl(), 'top-right')

//       new Marker({ color: '#FF0000' })
//         .setLngLat([106.67006969045394, 10.812570060914288])
//         .addTo(map.value)
//     })
//     onUnmounted(() => {
//       map.value?.remove()
//     })

//     return {
//       map, mapContainer
//     }
//   }
// }
</script>

<style scoped>
@import '~maplibre-gl/dist/maplibre-gl.css';

.map-iframe {
  width: 100%; /* Makes it responsive */
  height: 400px;
}

.map-wrap {
  position: relative;
  width: 100%;
  height: 500px;
  margin-bottom: 40px;
}

.map {
  position: absolute;
  width: 100%;
  height: 100%;
}

.watermark {
  position: absolute;
  left: 10px;
  bottom: 10px;
  z-index: 999;
}
</style>
